import axios from 'axios';
import { adalApiFetch, getToken, authContext } from '../../adalConfig';

const fetchClient = (url, params) => {
    const defaultOptions = {
        method: 'get',
        timeout: 1000 * 60,
        headers: {
            'Content-Type': 'application/json',
        }
    };

    // Create instance
    let instance = axios.create(defaultOptions);
    instance.defaults.timeout = 120000;

    // Set the AUTH token for any request
    instance.interceptors.request.use(function (config) {
        const token = getToken();
        config.headers.Authorization = token ? `Bearer ${token}` : '';
        return config;
    });

    // Add a 401 response interceptor
    instance.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (401 === error.response.status) {
            // handle error: inform user, go to login, etc
            if (authContext.getCachedUser()) {
                authContext.login();
            }
        } else {
            return Promise.reject(error);
        }
    });

    return instance;
};

export default fetchClient();


// WEBPACK FOOTER //
// ./src/components/common/FetchClient.js